import styled from "styled-components";
import { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect, DocumentPreview, DocumentPlaceholder } from "@/screen/Identities/Styles/IdentityFormStyles";
import { DisclaimerBox } from "@/screen/Identities/IdentityFiscalInputs/Styles/IdentityFiscalInputsStyles";
export { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect, DocumentPreview, DocumentPlaceholder, DisclaimerBox };

// Texto de pregunta legal (GAFI / personas políticamente expuestas)
export const QuestionText = styled.p`
    font-size: 14px;
    color: #2a4143;
    margin-bottom: 12px;
    line-height: 1.5;
    cursor: default;
`;

// Contenedor de opciones radio (Si/No)
export const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    margin-bottom: 8px;
`;

export const RadioLabel = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #2a4143;
    cursor: pointer;
`;

export const RadioInput = styled.input`
    cursor: pointer;
`;

export const FileFormatHint = styled.p`
    font-size: 11px;
    margin: 4px 0;
    cursor: default;
`;

export const FormFieldFull = styled(FormField)`
    flex: 1;
    width: 100%;
`;

export const FormFieldHalf = styled(FormField)`
    flex: 1;
`;

export const ProofOfIncomePlaceholderTitle = styled.span`
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
`;

export const ProofOfIncomeOptionsList = styled.ul`
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
    text-align: left;
    line-height: 1.6;
`;

export const TallDocumentPreview = styled(DocumentPreview)`
    height: 480px;
`;